import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { getSharesTransferLabels } from 'modules/transactions/utils/getSharesTransferLabels';

import { useOperationDetailsPage } from '../../context/OperationDetailsPageContext';

const SharesTransferOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = useOperationDetailsPage();
  const modalLabels = getSharesTransferLabels(
    data?.operation?.operationType || ''
  );

  return (
    <thead>
      <tr className="nk-tb-item tb-tnx-head">
        <th className="nk-tb-col text-left">
          {t(modalLabels.recipientPartner)}
        </th>

        <th className="nk-tb-col text-left">
          {t(modalLabels.transmittingPartner)}
        </th>

        <th className="nk-tb-col text-right">{t('NrPart')}</th>

        <th className="nk-tb-col text-right">{t('From')}</th>

        <th className="nk-tb-col text-right">{t('To')}</th>

        <th className="nk-tb-col text-center">{t('Class')}</th>

        <th className="nk-tb-col text-right">{t('Price')}</th>

        {/* <th className="nk-tb-col text-right">{t('Premium')}</th> */}

        <th className="nk-tb-col text-right">{t('Total')}</th>
      </tr>
    </thead>
  );
};

export default SharesTransferOperationTableHeader;
